import './CartDrawer.css'
import { useCart } from '../context/CartContext'

const inr = n => `₹${n.toLocaleString('en-IN')}`

export default function CartDrawer() {
  const { items, open, setOpen, setCheckout, dispatch, total } = useCart()
  const toCheckout = () => { setOpen(false); setCheckout(true) }

  return (
    <>
      <div className={`scrim ${open ? 'scrim--on' : ''}`} onClick={() => setOpen(false)} />
      <aside className={`drawer ${open ? 'drawer--on' : ''}`} aria-hidden={!open} aria-label="Cart">
        <div className="drawer__head">
          <h2>Your cart</h2>
          <button className="btn btn--sm" onClick={() => setOpen(false)}>Close</button>
        </div>
        {items.length === 0 ? <p className="empty">Your cart is empty. Add something from the shop.</p> : (
          <ul className="drawer__list">
            {items.map(i => (
              <li key={i.id}>
                <div><strong>{i.name}</strong><br />{inr(i.price)}</div>
                <div className="qty">
                  <button onClick={() => dispatch({ type: 'dec', id: i.id })} aria-label="Decrease">−</button>
                  <span>{i.qty}</span>
                  <button onClick={() => dispatch({ type: 'add', item: i })} aria-label="Increase">+</button>
                </div>
              </li>
            ))}
          </ul>
        )}
        {items.length > 0 && (
          <div className="drawer__foot">
            <p><span>Subtotal</span><strong>{inr(total)}</strong></p>
            <small>Delivery is calculated at checkout.</small>
            <button className="btn btn--cobalt" onClick={toCheckout}>Checkout</button>
            <button className="btn btn--sm" onClick={() => dispatch({ type: 'clear' })}>Clear cart</button>
          </div>
        )}
      </aside>
    </>
  )
}